export default "__VITE_ASSET__B4xGPRf1__"